// DS: i10.4
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const LinkedIn: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path d="M20.29 20.005h-3.374v-5.199c0-1.24-.023-2.835-1.754-2.835-1.757 0-2.026 1.351-2.026 2.746v5.288H9.762V9.315h3.239v1.46h.045c.45-.84 1.552-1.727 3.194-1.727 3.418 0 4.05 2.215 4.05 5.093v5.864zM5.958 7.853C4.876 7.853 4 6.989 4 5.926 4 4.863 4.876 4 5.958 4c1.08 0 1.956.863 1.956 1.926s-.877 1.927-1.956 1.927zM4.269 20.005V9.315h3.376v10.69H4.27z" />
      </g>
    </svg>
  </IconWrap>
);
LinkedIn.displayName = 'LinkedIn';

export default LinkedIn;
